import { Box } from '@mui/material';
import type { FC } from 'react';
import { useMemo, useState } from 'react';
import { Table } from 'src/common';
import type { TableData } from 'src/types/table';
import { SecurityDashboardCard } from '../../shared/securityDashboardCard';
import {
  buildActivityColumns,
  buildTableFilterFields,
  createEmptyTableFilters,
  EndpointTableFiltersToolbar,
  EVENT_TABLE_FILTER_IDS,
  EVENT_TABLE_FILTER_LABELS,
  TablePaginationFooter,
} from './shared/endpointTableTab';

const EMPTY_FILTERS = createEmptyTableFilters(EVENT_TABLE_FILTER_IDS);
const EMPTY_FILTER_OPTIONS: Record<(typeof EVENT_TABLE_FILTER_IDS)[number], string[]> = {
  severity: [],
  category: [],
  status: [],
  user: [],
  source: [],
};

/** Placeholder until endpoint activity APIs are wired. */
const EndpointActivityTimelineTab: FC = () => {
  const [dateRange, setDateRange] = useState('');

  const filterFields = useMemo(
    () => buildTableFilterFields(EVENT_TABLE_FILTER_LABELS, EMPTY_FILTER_OPTIONS),
    []
  );
  const columns = useMemo(() => buildActivityColumns(), []);

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 16, marginTop: 8, minWidth: 0 }}>
      <SecurityDashboardCard
        overflow="hidden"
        footerAlign="space-between"
        footer={(
          <TablePaginationFooter
            page={0}
            pageCount={1}
            showingFrom={0}
            showingTo={0}
            total={0}
            onPageChange={() => undefined}
          />
        )}
      >
        <EndpointTableFiltersToolbar
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
          fields={filterFields}
          selected={EMPTY_FILTERS}
          onChange={() => undefined}
        />

        <Table
          columns={columns}
          data={[] as TableData[]}
          showCheckbox
          selectedRows={[]}
          onSelectRows={() => undefined}
          showPagination={false}
          TableContainerProps={{ sx: { boxShadow: 'none', borderRadius: 0 } }}
        />
      </SecurityDashboardCard>
    </Box>
  );
};

export default EndpointActivityTimelineTab;
